<div class="tier-upgrade-content">
  <!-- Usage indicator -->
  <div class="usage-section">
    <div class="usage-icon">
      <i class="pi pi-exclamation-triangle"></i>
    </div>
    <p class="usage-message" *ngIf="message">{{ message }}</p>
    <p class="usage-message" *ngIf="!message">
      You've used all {{ limit }} {{ metricDisplayName | lowercase }} included in your current plan.
    </p>

    <!-- Progress bar -->
    <div class="usage-bar-container">
      <div class="usage-bar">
        <div class="usage-bar-fill" [style.width.%]="usagePercent"></div>
      </div>
      <div class="usage-numbers">
        <span>{{ currentUsage }} / {{ limit }} {{ metricDisplayName }} used</span>
      </div>
    </div>
  </div>

  <p-divider></p-divider>

  <!-- Upgrade options -->
  <div class="upgrade-section">
    <h4 class="upgrade-heading">Upgrade to unlock more</h4>

    <div class="tier-cards">
      <div
        *ngFor="let tier of upgradeTiers"
        class="tier-card"
        [class.recommended]="upgradeTiers.length > 1 && tier === upgradeTiers[upgradeTiers.length - 1]">
        <!-- Recommended badge -->
        <div
          class="recommended-badge"
          *ngIf="upgradeTiers.length > 1 && tier === upgradeTiers[upgradeTiers.length - 1]">
          Recommended
        </div>

        <div class="tier-card-header">
          <span class="tier-name">{{ tier.name }}</span>
          <span class="tier-price">{{ formatPrice(tier.price) }}<span class="price-period">/mo</span></span>
        </div>

        <div class="tier-metric-limit">
          <i class="pi pi-check-circle"></i>
          <span>{{ formatLimit(tier.limit) }} {{ metricDisplayName }}</span>
        </div>

        <!-- Agency pricing info -->
        <div class="tier-metric-limit" *ngIf="tier.agencyPricing && tier.agencyPricing.childrenAllowed">
          <i class="pi pi-users"></i>
          <span>${{ tier.agencyPricing.perChildMonthlyFee }}/mo per sub-account</span>
        </div>
        <div class="tier-metric-limit text-xs text-400" *ngIf="tier.agencyPricing && tier.agencyPricing.maxChildren > 0">
          <i class="pi pi-info-circle"></i>
          <span>Up to {{ tier.agencyPricing.maxChildren }} sub-accounts</span>
        </div>

        <p-button
          label="Upgrade to {{ tier.name }}"
          icon="pi pi-arrow-up"
          styleClass="p-button-primary w-full"
          (onClick)="selectTier(tier.tierId)">
        </p-button>
      </div>
    </div>

    <!-- Enterprise CTA -->
    <div class="enterprise-cta" *ngIf="hasEnterpriseTier()">
      <span>Need even more?</span>
      <a (click)="contactSales()" class="contact-link">Contact sales for Enterprise</a>
    </div>
  </div>

  <p-divider></p-divider>

  <!-- Dismiss -->
  <div class="dismiss-section">
    <p-button
      label="Not now"
      styleClass="p-button-text p-button-secondary"
      (onClick)="dismiss()">
    </p-button>
  </div>
</div>
